import React, { useState } from 'react'

import { Button, Dropdown } from '@fourthwall/components'
import { CalendarIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import * as S from './AnalyticsDropdown.styled'

type AnalyticsDropdownProps = {
  tabs: {
    options: Array<{
      label: string
      value: string
      params: object
    }>
    value: string
    onChange: (value: string) => void
  }
}

export const AnalyticsDropdown: React.FC<AnalyticsDropdownProps> = ({ tabs }) => {
  const [isOpen, setIsOpen] = useState(false)

  const currentTab = tabs.options.find((option) => option.value === tabs.value) || tabs.options[0]
  const currentLabel = currentTab?.label || ''

  const handleOptionClick = (value: string) => {
    tabs.onChange(value)
    setIsOpen(false)
  }

  const dropdownContent = (
    <S.DropdownContent>
      {tabs.options.map((option) => (
        <Dropdown.Item
          key={option.value}
          label={option.label}
          active={option.value === tabs.value}
          onClick={() => handleOptionClick(option.value)}
          cursor="pointer"
        />
      ))}
      <Dropdown.Divider />
      <Dropdown.Item label="View all analytics" to={routing.analytics.overview.self} />
    </S.DropdownContent>
  )

  return (
    <Dropdown
      content={dropdownContent}
      position="bottom-start"
      maxWidth={280}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <Button
        size="xsmall"
        appearance="secondary"
        label={currentLabel}
        leftIcon={<CalendarIcon />}
        onClick={() => setIsOpen(!isOpen)}
      />
    </Dropdown>
  )
}
